import React from 'react';

import { defaultLocale, TCurrency } from '@/config/locales';
import { IPrice } from '@/utility/mapSearchResultToTile';

import PriceCurrent from './PriceCurrent';
import PriceInstantBook from './PriceInstantBook';

type IPriceElement = React.HTMLAttributes<HTMLElement>;

export enum PriceSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface IProps extends IPrice {
  isCampground?: boolean;
  currency?: TCurrency;
  showDiscount?: boolean;
  showOriginalPrice?: boolean;
  size?: PriceSize;
  testId?: string;
  isMapPopup?: boolean;
}

const Price: React.FC<IProps & IPriceElement> = ({
  isCampground,
  size = PriceSize.medium,
  currency = defaultLocale.base_currency,
  discount,
  instantBook = false,
  originalPrice,
  currentPrice,
  estimatedPriceBreakdown,
  overrideDayPrice = 0,
  discountFromOverrideDayPrice = 0,
  showDiscount = isCampground ? discountFromOverrideDayPrice > 0 : discount > 0,
  showOriginalPrice = isCampground ? currentPrice < overrideDayPrice : currentPrice < originalPrice,
  testId = 'price',
  period,
  isMapPopup,
}) => {
  const hasDiscount = isCampground ? currentPrice < overrideDayPrice : currentPrice < originalPrice;

  return (
    <div
      className={`flex text-gray-900 items-baseline mt-1 ${
        showOriginalPrice ? 'flex-col ' : ''
      }lg:flex-row`}
      data-testid={testId}>
      <div className="flex items-baseline lg:contents">
        {instantBook && (
          <PriceInstantBook className="self-center" size={size} testId={`${testId}-instant-book`} />
        )}
        <PriceCurrent
          size={size}
          currency={currency}
          currentPrice={estimatedPriceBreakdown?.total ?? currentPrice}
          originalPrice={
            estimatedPriceBreakdown?.original_total ??
            (isCampground ? overrideDayPrice : originalPrice)
          }
          period={period}
          testId={`${testId}-current`}
          isMapPopup={isMapPopup}
          nights={estimatedPriceBreakdown?.duration}
          originalTotalPrice={estimatedPriceBreakdown?.original_total}
          showDiscount={showDiscount}
          hasDiscount={hasDiscount}
        />
      </div>
    </div>
  );
};

export default Price;
